import client from "shared/datasource/apiClient";
import { useGetApiData } from "shared/datalayer";
import PublicApi from "shared/enums/PublicApi";
import { ApiOrganizationFindByNameRequest, ApiProfileMap } from "./type";

export async function asyncOrganizationFn({ name, eventSeriesId, resultCount }: ApiOrganizationFindByNameRequest) {
  return client(PublicApi.FIND_ORGANIZATION_BY_NAME, {
    body: {
      name,
      eventSeriesId,
      resultCount
    }
  });
}

export function useGetOrganizationDetailsForRegistration({
  registrationFormId,
  organizationId,
  isAdminOnly = false
}: {
  registrationFormId?: string;
  organizationId?: string;
  isAdminOnly?: boolean;
}) {
  return useGetApiData<ApiProfileMap>(
    PublicApi.FIND_ORGANIZATION_DETAILS_FOR_REGISTRATION,
    { params: { registrationFormId, organizationId } },
    { enabled: Boolean(registrationFormId) && Boolean(organizationId) && !isAdminOnly }
  );
}
